import { useEffect, useMemo, useState } from 'react';
import { AddModalCont, AddModalLabel, AgencyInput, ModalButton, Warning, useStyles } from './Profiles.styles';

import {
  Checkbox,
  CircularProgress,
  Grid,
  ListItemText,
  MenuItem,
  Select as MuiSelect,
  Paper,
  Typography,
  useTheme,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { AddProfileIcon, Select, SelectArrowDownIcon } from '@room-match/shared-ui-components'; // Remove Close Icon
import { FormikProps, useFormik } from 'formik';
import React from 'react';
import { useQueryClient } from 'react-query';
import CloseIcon from 'shared/components/Icon/CloseIcon'; // Use talent app level folder Close Icon - Jerome
import { PROFILE_LINKS_QUERY_STRING } from 'shared/constants/QUERY_STRING';
import { RepresentationType } from 'shared/enums/RepresentationType';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { IProfileCreatePayload } from 'shared/interfaces/IProfile';
import { useAppSelector } from 'shared/redux/store';
import { agencyService } from 'shared/services/agencyService';
import { profileService } from 'shared/services/profileService';
import { useDebounce } from 'use-debounce';
import * as yup from 'yup';
import profileTypes from '../../data/ProfileType.json';

interface Props {
  onClose: VoidFunction;
  hasFreelance: boolean;
}

const { getAgencies } = agencyService();
const { createProfile } = profileService();

function AddModal({ onClose, hasFreelance }: Props) {
  const { user: userState } = useAppSelector((state) => state);
  const theme = useTheme();
  const classes = useStyles();

  //getuser medium_id
  const user = userState?.user || { attributes: { medium_id: '', country_code: 'au' } };
  const country = userState?.user?.attributes?.other_phone_numbers?.filter((num) => num.type === 'primary');
  const userCountry = country && country.length > 0 ? country[0].country_code : user?.attributes?.country_code || 'au';
  const [agencyId, setAgencyId] = useState('');
  const [codeRequired, setcodeRequired] = useState(false);
  const [divisions, setdivisions] = useState<{ id: string; name: string }[]>([]);
  const [disable, setdisable] = useState(true);
  const [duplicate, setDuplicate] = useState('');
  const [selectedDivisions, setselectedDivisions] = useState<string[]>([]);
  const { mutateAsync, isLoading: isLoadingCreateProfile } = createProfile();
  // const { mutate, isLoading: isMutationLoading } = createProfile();
  const queryClient = useQueryClient();
  const [inputValue, setinputValue] = useState('');
  const [debouncedVal] = useDebounce(inputValue, 500);
  const { width } = useWindowDimensions();

  const initialValues: IProfileCreatePayload = {
    representation_type: RepresentationType.AGENCY_REPRESENTATION,
    country: userCountry.toLowerCase() === 'au' ? 'Australia' : 'United States',
    note: '',
    agency_id: '',
    confirmed_agreement: false,
    profile_type: '',
    access_code: '',
  };

  const handleSubmit = async (values: IProfileCreatePayload, helpers: any) => {
    await mutateAsync(
      {
        ...values,
        ...(selectedDivisions.length && selectedDivisions[0] !== 'any' && { division_ids: [...selectedDivisions] }),
        agency_id: values.representation_type === 'Non-Represented' ? '' : agencyId,
      },
      {
        onSuccess: async () => {
          // PROFILE_LINKS_QUERY_STRING.PROFILE_LIST
          await queryClient.invalidateQueries('profiles');
          await queryClient.invalidateQueries(PROFILE_LINKS_QUERY_STRING.PROFILE_LIST, {
            refetchInactive: true,
          });
          helpers.resetForm();
          onClose();
          setAgencyId('');
        },
        onError: (err) => {
          if (
            (err?.response?.data.errors.agency && err?.response?.data.errors?.agency[0] === 'has already been taken') ||
            (err?.response?.data.errors.agency_id &&
              err?.response?.data.errors?.agency_id[0] === 'already have profile under this Agency')
          ) {
            setDuplicate('Profile for this agency already exist');
          } else if (
            err?.response?.data.errors.access_code &&
            err?.response?.data.errors?.access_code[0] === 'invalid'
          ) {
            setDuplicate('Invalid access code');
          } else if (
            err?.response?.data?.errors?.division_ids?.[0] === 'already have profile under this agency divisions'
          ) {
            setDuplicate('Already have profile under this agency division');
          }
        },
      },
    );
  };

  const createProfileValidationSchema = yup.object().shape({
    representation_type: yup.mixed<RepresentationType>().oneOf(Object.values(RepresentationType)).required(),
    country: yup.string().required(),
    note: yup.string(),
    agency_id: yup.string(),
    access_code: yup.string(),
    confirmed_agreement: yup.boolean().default(false),
    profile_type: yup.string().required(),
  });

  const form: FormikProps<IProfileCreatePayload> = useFormik({
    initialValues,
    validationSchema: createProfileValidationSchema,
    onSubmit: (values, helpers) => {
      handleSubmit(values, helpers);
      return;
    },
  });
  // console.log('ERRORS', form.errors);
  const { data: agencies, isLoading: isAgencyLoading } = getAgencies({
    country: form.values.country,
    search: debouncedVal,
  });

  const getData = useMemo(() => {
    if (isAgencyLoading) {
      return;
    } else {
      return agencies
        ? agencies.pages.filter((v, index) => index === 0).map((i) => i.data.agencies_connection.nodes)[0]
        : undefined;
    }
  }, [agencies, isAgencyLoading]);

  // const handleRepresentationChange = (e: React.ChangeEvent<{ value: unknown }>) => {
  //   setQuery('');
  //   form.setFieldValue(e.target., e.target.value);
  //   form.setFieldValue('agency_id', '');
  //   console.log(form);

  //   // setSelectedAgency(undefined);
  //   // setIsLargeDialog(false);
  // };

  const handleInputChange = (e: any) => {
    setinputValue(e.target.value);
  };

  const CustomPaper = (props: any) => {
    const theme = useTheme();
    return (
      <Paper
        {...props}
        style={{
          backgroundColor: theme.palette.type === 'dark' ? '#0d1117' : '#fff',
          border: theme.palette.type === 'dark' ? 'solid 1px #2d343e' : '1px solid #cdd9e9',
        }}
      />
    );
  };

  useEffect(() => {
    if (Object.values(form.errors).length) return setdisable(true);
    if (!Object.values(form.errors).length) setdisable(false);
  }, [form]);

  const MenuProps = {
    PaperProps: {
      style: {
        minWidth: 200,
      },
    },
  };

  const handleDivisionChange = (event: any) => {
    const {
      target: { value },
    } = event;

    if (Array.isArray(value)) {
      const index = value.indexOf('Any');
      if (index > -1) {
        value.splice(index, 1);
      }
    }

    if (value.indexOf('any') > -1) {
      setselectedDivisions(['any']);
    } else {
      setselectedDivisions(value);
    }
  };

  return (
    <AddModalCont width={width * 0.95}>
      <CloseIcon style={{ width: 16, alignSelf: 'flex-end', marginBottom: 30, cursor: 'pointer' }} onClick={onClose} />

      <AddProfileIcon style={{ width: 40, height: 40, marginBottom: 37 }} />
      <span style={{ fontSize: 24, marginBottom: 20 }}>Add a new Representative</span>
      <AddModalLabel>Representation Type</AddModalLabel>
      <Select
        variant="outlined"
        defaultValue={'Select'}
        fullWidth
        className={classes.select}
        data={[
          { key: 'Agency Representation', value: 'Agency Representation' },
          {
            key: form.values.country === 'United States' ? 'Non-Represented' : 'Freelance',
            value: 'Non-Represented',
          },
        ]}
        value={form.values.representation_type || ''}
        // IconComponent={SelectArrowDownIcon}
        name="representation_type"
        onChange={form.handleChange}
      />
      {hasFreelance && form.values.representation_type === 'Non-Represented' && (
        <Warning>Only one Non-Represented profile is allowed.</Warning>
      )}
      <Grid container spacing={2} style={{ marginTop: 5, display: 'flex' }}>
        <Grid item xs={12} md={6}>
          <AddModalLabel>Select Country</AddModalLabel>
          <Select
            variant="outlined"
            fullWidth
            data={[
              { value: 'United States', key: 'United States' },
              { value: 'Australia', key: 'Australia' },
            ]}
            value={form.values.country || ''}
            className={classes.select}
            // IconComponent={SelectArrowDownIcon}
            name="country"
            onChange={form.handleChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <AddModalLabel>Representation Type</AddModalLabel>
          <Select
            variant="outlined"
            fullWidth
            data={profileTypes}
            value={form.values.profile_type || ''}
            className={classes.select}
            // IconComponent={SelectArrowDownIcon}
            name="profile_type"
            onChange={form.handleChange}
          />
        </Grid>
        {form.values.representation_type !== 'Non-Represented' && (
          <Grid item xs={12}>
            <AddModalLabel>Select Agency / Manager</AddModalLabel>
            <Autocomplete
              onChange={(e, value: any) => {
                //clear division and code
                setselectedDivisions([]);
                form.setFieldValue('access_code', '');
                setDuplicate('');

                setAgencyId(value?.id || '');
                setcodeRequired(value?.required_access_code || false);
                setdivisions(value?.divisions.map((item: any) => ({ id: item.id, name: item.name })) || []);
              }}
              disabled={!form.values.country.length}
              fullWidth
              id="country-select-demo"
              // sx={{ width: 300 }}
              loading={isAgencyLoading}
              // open={inputValue.length > 0}
              options={getData || []}
              // autoHighlight
              // freeSolo
              ListboxProps={{ style: { maxHeight: 250 } }}
              PaperComponent={CustomPaper}
              popupIcon={<SelectArrowDownIcon />}
              noOptionsText="No Agency/Manager found"
              loadingText="Populating results"
              getOptionLabel={(option: any) => {
                //create a logic that will check current inputValue if it contains agency name then retunr the agency name else return the full name
                if (inputValue.length > 0) {
                  if (option?.full_name && option?.full_name?.toLowerCase()?.includes(inputValue?.toLowerCase())) {
                    return option?.full_name?.toLowerCase();
                  } else {
                    return option.name ? option.name : '';
                  }
                }

                return '';
              }}
              renderOption={(option: any) => {
                const { full_name, company_type, country, company_logo, name, type } = option;

                return (
                  <Grid container spacing={2} style={{ margin: 5, display: 'flex', alignItems: 'center' }}>
                    <Grid item xs={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <img
                        style={{ borderRadius: 10 }}
                        loading="lazy"
                        width="37"
                        src={company_logo || `https://ui-avatars.com/api/?background=random&name=${full_name}&length=1`}
                        alt=""
                      />
                    </Grid>
                    <Grid item xs={11}>
                      <Grid item xs={12} style={{ fontSize: 16, fontWeight: 500 }}>
                        {full_name || name}
                      </Grid>
                      <Grid item xs={12} style={{ color: '#93a1b6', fontSize: 14 }}>
                        <div style={{ display: 'flex' }}>
                          <p style={{ fontStyle: 'italic', fontSize: 12, fontWeight: 700 }}>
                            {name ? `${name} -\xa0` : ''}
                          </p>
                          <p style={{ fontStyle: 'italic', fontSize: 12 }}>{type ? type : ' '}</p>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                );
              }}
              renderInput={(params: any) => (
                <AgencyInput
                  onChange={handleInputChange}
                  variant="outlined"
                  placeholder="Type / Search your representation here"
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                  }}
                />
              )}
            />
          </Grid>
        )}

        {codeRequired && (
          <Grid item xs={12}>
            <AddModalLabel>Agency Code</AddModalLabel>
            <Typography
              style={{ fontSize: 12, marginTop: 3, color: theme.palette.type === 'dark' ? '#98a1ac' : '#484c52' }}
            >
              Please contact your agency for their security code, in order to add them as a representative.
            </Typography>
            <AgencyInput
              helperText={!form.values.access_code && 'Agency code is required'}
              error={!form.values.access_code}
              fullWidth
              name="access_code"
              onChange={form.handleChange}
              variant="outlined"
              value={form.values.access_code || ''}
            />
          </Grid>
        )}
        {divisions.length > 0 && (
          <React.Fragment>
            <AddModalLabel style={{ margin: '10px 10px -5px' }}>Divisions</AddModalLabel>
            <MuiSelect
              style={{ margin: '20px 10px' }}
              MenuProps={MenuProps}
              IconComponent={SelectArrowDownIcon}
              variant="outlined"
              fullWidth
              multiple
              onChange={handleDivisionChange}
              // startAdornment={
              //   <InputAdornment
              //     style={{ color: `${COLORS.PRIMARY} !important`, background: COLORS.DARK_GRAY }}
              //     position="start"
              //   >
              //     Division:
              //   </InputAdornment>
              // }
              value={selectedDivisions?.length > 0 ? selectedDivisions : []}
              renderValue={(selected: any) =>
                // selected.length > 1 ? `${selected.length} Selected` : selected[0] === 'All' ? 'All' : '1 Selected'
                selected.length > 1
                  ? `${divisions.find((f) => f.id === selected[0])?.name} +${selected.length - 1}`
                  : selected[0] === 'any'
                    ? 'Any'
                    : `${divisions.find((f) => f.id === selected[0])?.name}`
              }
              error={!selectedDivisions.length}
            >
              <MenuItem key={'any'} value={'any'}>
                <Checkbox checked={selectedDivisions.indexOf('any') > -1} color="primary" />
                <ListItemText primary={'Any'} style={{ textTransform: 'capitalize' }} />
              </MenuItem>
              {divisions.map((r) => (
                <MenuItem key={r.id} value={r.id} disabled={selectedDivisions.indexOf('any') > -1}>
                  <Checkbox checked={selectedDivisions.indexOf(r.id) > -1} color="primary" />
                  <ListItemText primary={r.name} style={{ textTransform: 'capitalize' }} />
                </MenuItem>
              ))}
            </MuiSelect>
          </React.Fragment>
        )}
      </Grid>
      {!form.values.country.length ? <Warning>Note: Select a country to select an agency / manager.</Warning> : <></>}

      <Grid container spacing={2} style={{ marginTop: 'auto' }}>
        {duplicate ? (
          <Warning style={{ marginLeft: 10 }}>{duplicate}</Warning>
        ) : (
          <Warning
            style={{ marginLeft: 10, color: theme.palette.type === 'dark' ? '#98a1ac' : '#484c52', marginBottom: 5 }}
          >
            <span style={{ color: '#3e8bff' }}>Note:</span> If your agency is not listed here please contact your agency
          </Warning>
        )}
        <Grid item xs={6}>
          <ModalButton
            style={{ backgroundColor: '#303946', color: 'white' }}
            fullWidth
            variant="contained"
            disableElevation
            onClick={() => form.resetForm()}
          >
            Reset
          </ModalButton>
        </Grid>
        <Grid item xs={6} style={{ marginBottom: 20 }}>
          <ModalButton
            fullWidth
            color="primary"
            variant="contained"
            disableElevation
            onClick={() => form.handleSubmit()}
            disabled={
              (hasFreelance && form.values.representation_type === 'Non-Represented') ||
              !form.isValid ||
              !form.dirty ||
              (form.values.representation_type === 'Non-Represented' ? false : !agencyId) ||
              (codeRequired && !form.values.access_code) ||
              (divisions.length && !selectedDivisions.length) ||
              isLoadingCreateProfile
            }
            // onClick={() => console.log('submit', form.values)}
          >
            {isLoadingCreateProfile ? <CircularProgress size={25} /> : 'Add Representative'}
          </ModalButton>
        </Grid>
      </Grid>
    </AddModalCont>
  );
}

export default AddModal;
